/* eslint-env jquery */

import Raven from 'raven-js';
import Snap from 'snapsvg-cjs';
import * as THREE from 'three';

// Install Raven in production envs
if (process.env.NODE_ENV === 'production') {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}

// eslint-disable-next-line one-var
let container,
    camera,
    scene,
    renderer,
    particles,
    geometry,
    parameters,
    h,
    color,
    size;

const Detector = {

    canvas: !!window.CanvasRenderingContext2D,
    webgl: (function () {
        try {
            const canvas = document.createElement('canvas'); return !!(window.WebGLRenderingContext &&
                (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
        } catch (e) {
            return false;
        }
    }()),
    workers: !!window.Worker,
    fileapi: window.File && window.FileReader && window.FileList && window.Blob,

    getWebGLErrorMessage() {
        const element = document.createElement('div');
        element.id = 'webgl-error-message';
        element.style.fontFamily = 'monospace';
        element.style.fontSize = '13px';
        element.style.fontWeight = 'normal';
        element.style.textAlign = 'center';
        element.style.background = '#fff';
        element.style.color = '#000';
        element.style.padding = '1.5em';
        element.style.width = '400px';
        element.style.margin = '5em auto 0';

        if (!this.webgl) {
            element.innerHTML = window.WebGLRenderingContext ? [
                'Your graphics card does not seem to support ' +
                '<a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.' +
                '<br />',
                'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.',
            ].join('\n') : [
                'Your browser does not seem to support ' +
                '<a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.' +
                '<br/>',
                'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.',
            ].join('\n');
        }

        return element;
    },

    addGetWebGLMessage(params) {
        parameters = params || {};

        const parent = parameters.parent !== undefined ? parameters.parent : document.body;
        const id = parameters.id !== undefined ? parameters.id : 'oldie';

        const element = Detector.getWebGLErrorMessage();
        element.id = id;

        parent.appendChild(element);
    },

};

const materials = [];
const mouseX = 0;
const mouseY = 0;

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

function init() {
    let i;
    for ((container = document.createElement("div")).className = "threejs_codex",
             document.body.appendChild(container),
             (camera = new THREE.PerspectiveCamera(75, window.innerWidth /
                 window.innerHeight, 1, 3e3)).position.z = 1e3,
             (scene = new THREE.Scene()).fog = new THREE.FogExp2(0, 7e-4), geometry = new THREE.Geometry(),
             i = 0; i < 2e4; i++) {
        const e = new THREE.Vector3();
        e.x = (30e3 * Math.random()) - 1e3;
        e.y = (2e3 * Math.random()) - 1e3;
        e.z = (2e3 * Math.random()) - 1e3;
        geometry.vertices.push(e);
    }
    for (parameters = [[[1, 1, 0.5], 3], [[0.95, 1, 0.5], 4], [[0.9, 1, 0.5], 3], [[0.85, 1, 0.5], 2], [[0.8, 1, 0.5],
        1]], i = 0; i < parameters.length; i++) {
        color = parameters[i][0];
        size = parameters[i][1];
        materials[i] = new THREE.PointsMaterial({size});
        particles = new THREE.Points(geometry, materials[i]);
        particles.rotation.x = 6 * Math.random();
        particles.rotation.y = 6 * Math.random();
        particles.rotation.z = 6 * Math.random();
        scene.add(particles);
    }
    renderer = new THREE.WebGLRenderer({alpha: true});
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    container.appendChild(renderer.domElement);
    // document.addEventListener("touchstart", onDocumentTouchStart, !1),
    // document.addEventListener("touchmove", onDocumentTouchMove, !1), document.addEventListener("mousemove",
    // onDocumentMouseMove, !1),
    // I disabled camera motion because it has a very high performance hit on Chrome, for example
    window.addEventListener("resize", onWindowResize, !1);
}

function render() {
    let i;
    const e = 5e-5 * Date.now();
    for (camera.position.x += 0.05 * (mouseX - camera.position.x),
             camera.position.y += 0.05 * (-mouseY - camera.position.y),
             camera.lookAt(scene.position), i = 0; i < scene.children.length; i++) {
        const n = scene.children[i];
        // eslint-disable-next-line no-unused-expressions
        n instanceof THREE.Points && (n.rotation.x = e * (i < 4 ? i + 1 : -(i + 1)));
    }
    for (i = 0; i < materials.length; i++) {
        color = parameters[i][0];
        h = ((360 * (color[0])) % 360) / 360;
        materials[i].color.setHSL(h, color[1], color[2]);
    }
    renderer.render(scene, camera);
}

function animate() {
    requestAnimationFrame(animate);
    render();
}

function scrollToTarget(selector) {
    const target = $(selector);
    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top,
        }, 500);
    }
}

// eslint-disable-next-line no-unused-expressions
Detector.webgl || Detector.addGetWebGLMessage();

function makeSnake() {
    const map = Snap("#snakePath");
    const snakePath = map.path('M512,0L512 96 160 96 160 224 864 224 864 160 224 160 224 288 32 288 32 352 416 ' +
        '352 416 192 576 192 576 288 320 288 320 384 640 384 640 288 736 288 736 352 800 352 800 288 960 288 960 ' +
        '448 576 448 576 320 512 320 512 512 224 512 224 320 128 320 128 416 288 416 288 480 64 480 64 576 352 576 ' +
        '352 448 544 448 544 544 416 544 416 608 608 608 608 480 704 480 704 384 896 384 896 576 800 576 800 416 ' +
        '640 416 640 576 448 576 448 640 320 640 320 448 96 448 96 704 160 704 160 544 384 544 384 608 256 608 ' +
        '256 704 864 704 864 512 704 512 704 640 512 640 512 768 ').attr({
            fill: 'none',
            stroke: 'none',
        });

    const snakePathLength = Snap.path.getTotalLength(snakePath); // ~12k px

    let snakeParts = [];

    function moveSnakePart(part, partBBox, distance) {
        const moveToPoint = Snap.path.getPointAtLength(snakePath, distance);
        const x = moveToPoint.x - (partBBox.width / 2);
        const y = moveToPoint.y - (partBBox.height / 2);
        part.transform(`translate(${x}, ${y})`);
    }

    $(window).scroll(() => {
        // calculate how far down the page the user is
        const startPos = $(window).height() / 4;
        if ($(window).scrollTop() >= startPos) { // TRIGGER SNAEK
            if (($(window).scrollTop() - startPos >= snakeParts.length * 20) && (snakeParts.length < 20)) {
                // Create a new snake part until full
                const tempPart = map.rect(0, 0, 16, 16).attr({
                    fill: `rgba(182, 1, 58, ${(1 - (snakeParts.length / 30)) / 2})`, // Gradually fade to transparent
                });
                const tempBBox = tempPart.getBBox();

                snakeParts.push({
                    part: tempPart,
                    bbox: tempBBox,
                });
            }

            const percentage = ((($(window).scrollTop() - startPos) /
                ($("html").height() - startPos - $(window).height())) * 100);
            const nextDistance = (snakePathLength / 100) * percentage;

            snakeParts.forEach((partObj, j) => {
                moveSnakePart(partObj.part, partObj.bbox,
                (nextDistance - (j * 20)) > 1 ? (nextDistance - (j * 20)) : 1);
            });
        } else { // You've moved too far up so delete the snake
            snakeParts.forEach((partObj) => { partObj.part.remove(); });
            snakeParts = [];
        }
    });

    $('.scrollTo').on('click', function (e) {
        e.preventDefault();
        const href = $(this).attr('href');
        if (href && href[0] === '#') {
            scrollToTarget(href);
        }
    });

    $('.reveal').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $(this).siblings('.d-none').each(function () {
            $(this).removeClass('d-none');
        });
    });

    const $bdy = $('.body');

    $('.btn-menu').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open', 'closed');
        $bdy.toggleClass('hidden');
        $('.menu').toggleClass('closed');
        if (!$('.coc').hasClass('closed')) {
            $('.coc').addClass('closed');
        }
    });
    $('.menu a:not(".btn-coc")').on('click', function (e) {
        const href = $(this).attr('href');
        $('.btn-menu').toggleClass('open', 'closed');
        $('.menu').toggleClass('closed');
        $bdy.toggleClass('hidden');
        if (href && href[0] === '#') {
            e.preventDefault();

            scrollToTarget(href);
        }
    });
    $('.btn-coc').on('click', (e) => {
        e.preventDefault();
        $('.coc').toggleClass('closed');
    });
}


export {init, animate, makeSnake}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/main.js